import { Component } from '@angular/core';
import { XpoLtlAuthenticationService } from '@xpo-ltl/ngx-auth';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { ConfigManagerProperties } from './enums/config-manager-properties.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  build: string;

  constructor(
    private configManagerService: ConfigManagerService,
    private authService: XpoLtlAuthenticationService
  ) {
    const region = this.configManagerService.getSetting<string>(ConfigManagerProperties.region);
    this.authService.initAuthSetup$(region).subscribe();
    const prod = this.configManagerService.getSetting<boolean>(ConfigManagerProperties.production);
    if (prod) {
      this.build = this.configManagerService.getSetting<string>(ConfigManagerProperties.buildVersion);
    } else {
      this.build = `${this.configManagerService.getSetting<string>(ConfigManagerProperties.buildVersion)} - ${region}`;
    }
  }
}
